import Router from '../utils/router';
import ConversationDetailsActionTypes from '../types/conversation_details';
import Q from 'q';

const ConversationDetailsActions = { types: ConversationDetailsActionTypes };

ConversationDetailsActions.show = function() {
  return {
    type: ConversationDetailsActions.types.SHOW
  };
};

ConversationDetailsActions.hide = function() {
  return {
    type: ConversationDetailsActions.types.HIDE
  };
};

ConversationDetailsActions.open = function (options) {
  return function(dispatch, getState) {
    if (!getState().conversationDetails.visible) {
      dispatch(ConversationDetailsActions.show());
    }
  };
};

ConversationDetailsActions.close = function (options) {
  return function(dispatch, getState) {
    if (getState().conversationDetails.visible) {
      dispatch(ConversationDetailsActions.hide());
    }
  };
};

export default ConversationDetailsActions;
